// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1967":"cbd3bc1d0f9b4ee6","4899":"8e9d49293a6d8b3c","7194":"3f7edc6d8cf295ca","7767":"ec9c3af5b49ff65a","7796":"f2bd081c1bf0ce9c","9335":"0e54eebf9a3e92cd"}[chunkId] + ".css";
};